<template>
	<div class="max-width">
		<div class="subs">
			<router-link to="/" class="subs__links">Home</router-link>
			<router-link to="/help-center/" class="subs__links"
				>Help Center</router-link
			>
			<span>Mix</span>
		</div>

		<div class="sh-documentation-theme">
			<aside class="sh-documentation-theme__sidebar">
				<div class="sh-documentation-theme__sidebar-inner">
					<div class="sh-documentation-theme__sidebar-nav">
						<div class="sh-documentation-theme__sidebar-wrapper">
							<ul class="sh-documentation-theme__sidebar-list">
								<li class="sh-documentation-theme__sidebar-list-item">
									<a href="#theme-settings">Theme Settings</a>
									<ul class="sh-documentation-theme__sidebar-sublist">
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#product-card">Product Card</a>
											<ul class="sh-documentation-theme__sidebar-sublist">
												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#custom-badges">Custom Product Badges</a>
												</li>
											</ul>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#pagination">Pagination</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#back-to-top">Back to Top</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#color-swatches">Color Swatches</a>
											<ul class="sh-documentation-theme__sidebar-sublist">
												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#color-swatches-multilanguage"
														>Multilanguage Color Swatches</a
													>
												</li>
											</ul>
										</li>
									</ul>
								</li>
								<li class="sh-documentation-theme__sidebar-list-item">
									<a href="#header-group">Header Group</a>
									<ul class="sh-documentation-theme__sidebar-sublist">
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#announcement-bar">Announcement Bar</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#header">Header</a>
											<ul class="sh-documentation-theme__sidebar-sublist">
												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#header-mega-menu">Mega Menu Blocks</a>
													<ul class="sh-documentation-theme__sidebar-sublist">
														<li
															class="sh-documentation-theme__sidebar-sublist-item"
														>
															<a href="#header-mega-menu-cards"
																>Mega Menu with Cards</a
															>
														</li>
														<li
															class="sh-documentation-theme__sidebar-sublist-item"
														>
															<a href="#header-mega-menu-tabs"
																>Mega Menu with Tabs</a
															>
														</li>
														<li
															class="sh-documentation-theme__sidebar-sublist-item"
														>
															<a href="#header-mega-menu-multilanguage"
																>Multilanguage Mega Menu Trigger</a
															>
														</li>
													</ul>
												</li>
												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#header-search">Search Modal</a>
												</li>
											</ul>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#shop-mega-menu">Shop Mega Menu Section</a>
										</li>
									</ul>
								</li>
								<li class="sh-documentation-theme__sidebar-list-item">
									<a href="#overlay-group">Overlay Group</a>
									<ul class="sh-documentation-theme__sidebar-sublist">
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#popup">Popup</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#notification-bar">Notification Bar</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#age-verifier">Age Verification Popup</a>
										</li>
									</ul>
								</li>
								<li class="sh-documentation-theme__sidebar-list-item">
									<a href="#footer-group">Footer Group</a>
									<ul class="sh-documentation-theme__sidebar-sublist">
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#footer">Footer</a>
										</li>
									</ul>
								</li>
								<li class="sh-documentation-theme__sidebar-list-item">
									<a href="#all-sections">Sections</a>
									<ul class="sh-documentation-theme__sidebar-sublist">
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#sections-general-settings">General Settings</a>
											<ul class="sh-documentation-theme__sidebar-sublist">
												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#section-margin">Section Margin</a>
												</li>
												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#section-padding">Section Padding</a>
												</li>
											</ul>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#featured-collection">Featured Collection</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#featured-product">Featured Product</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#rte">Rich Text</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#slideshow">Slideshow</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#multicolumn">Multicolumn</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#collapsible-content">Collapsible Content</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#banner-grid">Banner Grid</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#banner-slider">Banner Slider</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#blog-posts">Blog Posts</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#brands">Brands</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#collections-list">Collections List</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#countdown">Countdown</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#product-carousel">Popular Products</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#product-markers">Product Markers</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#product-tabs">Products Ttabs</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#testimonials">Testimonials</a>
										</li>
									</ul>
								</li>
								<li class="sh-documentation-theme__sidebar-list-item">
									<a href="#page">Pages</a>
									<ul class="sh-documentation-theme__sidebar-sublist">
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#product-page">Product Page</a>
											<ul class="sh-documentation-theme__sidebar-sublist">
												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#product-information">Product Information</a>
												</li>

												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#product-recommendations"
														>Product Recommendations</a
													>
												</li>
											</ul>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#collections-page">Collections Page</a>
											<ul class="sh-documentation-theme__sidebar-sublist">
												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#collection-banner">Collection Banner</a>
												</li>
												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#product-grid">Product Grid</a>
												</li>
											</ul>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#collections-list-page">Collections List</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#cart">Cart</a>
											<ul class="sh-documentation-theme__sidebar-sublist">
												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#cart-shipping">Free shipping message</a>
												</li>
											</ul>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#blog">Blog</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#blog-post">Blog Post</a>
										</li>
									</ul>
								</li>
								<li class="sh-documentation-theme__sidebar-list-item">
									<a href="#support">Support</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</aside>
			<div class="sh-documentation-theme__content">
				<div class="sh-content">
					<h1 id="started">Mix</h1>
					<p>
						Below you’ll find a list of articles broken down by sub topics that
						cover each and every aspect of your theme. We regularly maintain our
						documentation in collaboration with our support staff.
					</p>

					<!------------------------------ THEME SETTINGS (START) ------------------------------>

					<h2 id="theme-settings">Theme Settings</h2>

					<p>With the Theme settings, you can:</p>
					<ul>
						<li>Customize the appearance of text elements</li>
						<li>Manage color schemes</li>
						<li>Upload a favicon</li>
						<li>Control the appearance of product cards</li>
						<li>
							Manage the Quick View and Quick Add buttons inside product cards
						</li>
						<li>Enable and customize color swatches</li>
						<li>
							Manage Predictive Search (please note: Predictive Search is not
							supported in Shopify for some languages)
						</li>
						<li>Enable and customize the Cart Drawer for faster purchases</li>
						<li>
							Customize pagination (limited to pages specified in the notes)
						</li>
						<li>Add links to your social media</li>
						<li>
							Apply custom CSS styles if you need to override the theme's
							default styles
						</li>
					</ul>
					<figure>
						<img src="/assets/imgs/docs/mix/theme_settings_1.webp" />
					</figure>

					<h3 id="product-card">Product Card</h3>
					<p>
						In the Theme settings > Product card section, you can customize the
						appearance of product cards across the entire theme.
					</p>
					<figure>
						<img src="/assets/imgs/docs/mix/product_card_1.webp" />
					</figure>
					<ol>
						<li>
							The <b>Regular price</b> setting defines the text color of the product's regular (non-discounted) price.
						</li>
						<li>
							The <b>Price after sale</b> setting defines the text color of the product price shown after discount.
						</li>
						<li>
							The <b>Price before sale</b> setting defines the text color of the original price displayed when a product is on sale.
						</li>
						<li>
							The <b>Show discount badge</b> setting enables or disables the display of a discount badge on product cards.
						</li>
						<li>
							The <b>Discount badge type</b> setting lets you choose how the discount is displayed, either as a <b>Percentage</b> or as an <b>Label "Sale"</b>.
						</li>
						<li>
							The <b>Show Sold out badge</b> setting enables a badge to be displayed when the product is out of stock.
						</li>
						<li>
							The <b>Show Custom badge</b> setting allows you to display a custom badge using a metafield.  
							To use this option, create a metafield <code>custom.badges</code> in Shopify admin with the type <b>Single line text</b>.
						</li>
						<li>
							The <b>Custom badge color scheme</b> setting lets you select the color scheme for the custom badge.
						</li>
						<li>
							The <b>Enable hover effect</b> setting activates a hover interaction on product cards.
						</li>
					</ol>

					<h3 id="custom-badges">Custom Product Badges</h3>
					<p>
						To enable Custom Product badges, need add a metafield <code>custom.product_badges</code> in Shopify admin.
					</p>
					<figure>
						<img src="/assets/imgs/docs/mix/custom_badges_1.webp" />
					</figure>
					<p>The next step is to add metafields to the products.</p>
					<p>To add and edit metafields, follow these steps:</p>
					<ol>
						<li>
							Navigate to Settings > Metafields and metaobjects in the Admin panel > Click the button "Add definition".
							<figure>
								<img src="/assets/imgs/docs/mix/custom_badges_2.webp" />
							</figure>
						</li>
						<li>
							Fill the fields. In the <b>Name</b> field enter "Product badges" so that
							"product_badges" appears in the Type field.
							In the <b>Fields</b> section add:
							<ul>
								<li><b>Text</b> (Single line text) — key: <code>product_badges.text</code></li>
								<li><b>Icon</b> (File) — key: <code>product_badges.icon</code></li>
								<li><b>Color background</b> (Color) — key: <code>product_badges.color_background</code></li>
								<li><b>Color text</b> (Color) — key: <code>product_badges.color_text</code></li>
							</ul>
							<figure>
								<img src="/assets/imgs/docs/mix/custom_badges_3.webp" />
							</figure>
						</li>
						<li>
							Select Products.
							<figure>
								<img src="/assets/imgs/docs/mix/custom_badges_4.webp" />
							</figure>
						</li>
						<li>
							Click the button "Add definition".
							<figure>
								<img src="/assets/imgs/docs/mix/custom_badges_5.webp" />
							</figure>
						</li>
						<li>
							Fill the fields. In the <b>Name</b> field enter "Product badges" so that
							"custom.product_badges" appears in the Namespace and Key field.  
							In the <b>Content type</b> section select <b>Mixed reference</b>.  
							In the <b>References</b> field choose <b>Product badges</b> and set limit to "One entry".
							<figure>
								<img src="/assets/imgs/docs/mix/custom_badges_6.webp" />
							</figure>
						</li>
						<li>
							Go to <b>Content → Metaobjects</b> and make sure that the definition
							<b>Product badges</b> has been created successfully.  
							You should see it in the list with the assigned author and number of entries.
							<figure>
								<img src="/assets/imgs/docs/mix/custom_badges_7.webp" />
							</figure>
						</li>
						<li>
							Click the button "Add entry".
							<figure>
								<img src="/assets/imgs/docs/mix/custom_badges_8.webp" />
							</figure>
						</li>
						<li>
							Add a new entry for <b>Product badges</b>.  
							Fill in the following fields:
							<ul>
								<li><b>Text</b> — enter the display name of the badge</li>
								<li><b>Icon</b> — upload the file for the badge icon</li>
								<li><b>Color background</b> — choose the background color</li>
								<li><b>Color text</b> — choose the text color</li>
							</ul>
							Make sure the <b>Status</b> is set to <b>Active</b>.
							<figure>
								<img src="/assets/imgs/docs/mix/custom_badges_9.webp" />
							</figure>
						</li>
						<li>
							Go to <b>Products</b> and open the product where you want to display a badge.  
							In the <b>Product metafields</b> section find <b>Product badges</b> and select the
							corresponding entry from the list (for example: <i>Mega Sale</i>, <i>Best Seller</i>, etc.).
							<figure>
								<img src="/assets/imgs/docs/mix/custom_badges_10.webp" />
							</figure>
						</li>
					</ol>

					<h3 id="pagination">Pagination</h3>
					<p>
						For collection list pages, product list pages and the blog page you can configure the pagination type. To select
						pagination type, navigate to Theme settings > Pagination >
						Pagination type.
					</p>
					<ol>
						<li>
							Classic pagination type
							<figure>
								<img src="/assets/imgs/docs/mix/pagination_1.webp" />
							</figure>
						</li>
						<li>
							Load more type
							<figure>
								<img src="/assets/imgs/docs/mix/pagination_2.webp" />
							</figure>
						</li>
						<li>
							Infinite scroll type
							<figure>
								<img src="/assets/imgs/docs/mix/pagination_3.webp" />
							</figure>
						</li>
					</ol>

					<h3 id="back-to-top">Back to Top</h3>
					<p>
						To enable Back to Top button, navigate to Theme settings > Advanced.
					</p>
					<figure>
						<img src="/assets/imgs/docs/mix/back_to_top.webp" />
					</figure>

					<h3 id="color-swatches">Color Swatches</h3>
					<p>
						To enable and edit Color swatches, navigate to Theme settings >
						Color swatch.
					</p>
					<p>
						If product color options are added via
						<a
							href="https://help.shopify.com/en/manual/custom-data/metafields/category-metafields/using-category-metafields"
							aria-label="Category metafields in Shopify Help Center"
							target="_blank"
							><b>category metafields</b></a
						>, they will <b>automatically</b> appear in the following locations:
					</p>
					<ul>
						<li>On the product page</li>
						<li>In the featured product section</li>
						<li>
							On the collection page in filters. Customize filters with the
							<a
								href="https://help.shopify.com/en/manual/online-store/search-and-discovery/filters"
								aria-label="Category metafields in Shopify Help Center"
								target="_blank"
								>Search and Discovery app</a
							>.
						</li>
					</ul>
					<p>
						If the product color option is added as a <b>custom option</b>, the
						Swatch trigger field must be filled in to display color swatches.
						You can also add custom colors by adding their name and color in HEX
						format.
					</p>
					<p>
						To display color swatches on the <b>product card</b>, the Swatch
						trigger field must also be filled in.
					</p>
					<figure>
						<img src="/assets/imgs/docs/mix/color_swatches_2.webp" />
					</figure>

					<h3 id="color-swatches-multilanguage">
						Multilanguage Color Swatches
					</h3>
					<p>
						In this section, we will show how to create multilingual color
						swatches using the
						<a
							href="https://apps.shopify.com/translate-and-adapt"
							aria-label="Shopify Translate & Adapt app"
							target="_blank"
							>Shopify Translate & Adapt app</a
						>
						as an example.
					</p>

					<p>
						After translating the store with the Translate & Adapt app, the
						values of the <b>Swatch trigger</b> and <b>Custom colors</b> fields
						in Theme settings > Color swatch will also be translated.
					</p>
					<p>
						For color swatches to work correctly, make sure that the translation
						of the option in <b>Swatch trigger</b> in the
						<i>Translate & Adapt > Theme > Theme settings > Color swatch</i>
						matches the option name in the product. Additionally, if you fill in
						the <b>Custom colors</b> field, make sure that the translations of
						the color names match the translations of the colors within the
						option.
					</p>
					<p>
						Important: On the product page and in filters, color swatches will
						work automatically and are not dependent on the
						<b>Swatch trigger</b> field if the product option is linked to a
						Category metafield.
					</p>

					<figure>
						<img
							src="/assets/imgs/docs/mix/color_swatches_translate_1.webp"
						/>
					</figure>
					<figure>
						<img
							src="/assets/imgs/docs/mix/color_swatches_translate_2.webp"
						/>
					</figure>

					<!------------------------------ THEME SETTINGS (END) ------------------------------>

					<!------------------------------ HEADER GROUP (START) ------------------------------>

					<h2 id="header-group">Header Group</h2>

					<p>Sections that are used on all pages by default.</p>

					<h3 id="announcement-bar">Announcement Bar</h3>
					<p>
						The announcement bar appears at the top of every page and includes
						countdown timer, custom messages with optional links. It's good to
						use for promoting sales or need-to-know updates.
					</p>
					<figure>
						<img src="/assets/imgs/docs/mix/ann_bar_1.webp" />
					</figure>
					<ol>
						<li>
							<b>Color scheme</b> selector allows you to change the color
							scheme. You can change the colors in the <b>Theme settings</b>.
						</li>
						<li>
							<b>Height</b> slider allows you to change the announcement
							height only on desktop devices.
						</li>
						<li>
							<b>Height on mobile devices</b> slider allows you to
							change the announcement height only on mobile devices.
						</li>
						<li>
							<b>Text</b> field allows you to add and edit text for display.
						</li>
						<li>
							<b>Countdown timer options</b> allow you to place and manage a
							countdown timer.
						</li>
					</ol>

					<h3 id="header">Header</h3>
					<p>You can customize the header.</p>
					<figure>
						<img src="/assets/imgs/docs/mix/header_1.webp" />
					</figure>
					<ol>
						<li>
							<b>Color scheme</b> selector allows you to change the color
							scheme. You can change the colors in the <b>Theme settings</b>.
						</li>
						<li>
							Use the <b>Logo</b> file selector allows you to select or upload your logo file.
						</li>
						<li>
							Use the <b>Secondary logo</b> file selector to select or upload your logo, which can be seen in Dark mode.
						</li>
						<li>
							 Choose a <b>Menu</b> to be displayed in the header.
						</li>
						<li><b>Enable country/region selector</b> field enables the display of country/region.</li>
						<li><b>Enable language selector</b> field enables the display of language.</li>
						<li><b>Enable dark mode selector</b> field enables the display of color scheme switcher buttons.</li>
						<li>
							Use the <b>Sticky header</b> field to select a variant of the
							header when user scrolls in page.
						</li>
						<li><b>Search options</b> allows you to add Search modal and customize it.</li>
						<li>
							<b>Shop mega menu button </b> options allow you to configure the
							display of the Shop All button, which is linked to the
							<a href="#shop-mega-menu" aria-label="Shop mega menu"
								>Shop Mega Menu section</a
							>. This button is intended for use in the store’s global catalog
							menu. If it’s not linked to the Shop Mega Menu section, it will
							direct users to the page specified in the Button link field.
						</li>
					</ol>

					<h4 id="header-search">Search Modal</h4>
					<p>
						In the Search modal, you can add an a list of
						<b>popular products</b>, as well as <b>promo banner</b> that allow
						you to configure a promotional banner where you can set an image or
						video and display a message about a collection or promotion. The
						Search modal will appear beneath the search interface when the
						search input is focused.
					</p>
					<figure>
						<img src="/assets/imgs/docs/mix/header_search_1.webp" />
					</figure>
					<p>
						In this theme, you can use a <b>predictive search</b>. It is enabled
						by default for header, but you can disable it in the Theme settings
						> Search.
					</p>
					<figure>
						<img src="/assets/imgs/docs/mix/predictive_search_1.webp" />
					</figure>

					<h4 id="header-mega-menu">Mega Menu Blocks</h4>

					<h4 id="header-mega-menu-cards">Mega Menu with Columns</h4>
					<p>
						Mega menu allows you to display up to 8 columns, each with its own heading
						and submenu.
					</p>
					<figure>
						<img src="/assets/imgs/docs/mix/mega_menu_columns_1.webp" />
					</figure>
					<ol>
						<li>Add the Mega menu with columns block to the Header.</li>
						<li>
							Type the exact name of the link in the <b>Trigger</b> field.
						</li>
						<li>
							Fill in the columns, for each column you can customize <b>Heading</b> and
							<b>menu</b>.
						</li>
					</ol>

					<h4 id="header-mega-menu-tabs">Mega Menu with Tabs</h4>
					<p>
						Mega menu allows you to display up to 8 tabs, each with its own icon
						and submenu.
					</p>
					<figure>
						<img src="/assets/imgs/docs/mix/mega_menu_tabs_1.webp" />
					</figure>
					<ol>
						<li>Add the Mega menu with cards block to the Header.</li>
						<li>
							Type the exact name of the link in the <b>Trigger</b> field.
						</li>
						<li>
							Fill in the tabs, for each tab you can customize <b>Title</b>,
							<b>Link</b>, <b>Icon</b> and inner <b>Menu</b>.
						</li>
					</ol>

					<h4 id="header-mega-menu-multilanguage">
						Multilanguage Mega Menu Trigger
					</h4>
					<p>
						In this section, we will show how to create multilingual mega menu
						trigger using the
						<a
							href="https://apps.shopify.com/translate-and-adapt"
							aria-label="Shopify Translate & Adapt app"
							target="_blank"
							>Shopify Translate & Adapt app</a
						>
						as an example.
					</p>

					<p>
						After translating the store with the Translate & Adapt app, the
						value of the <b>Trigger</b> field in Theme > Header group > Header >
						Mega menu block will also be translated.
					</p>
					<p>
						For the mega menu to work correctly in all languages, you need to
						ensure that the value in the <b>Mega Menu Trigger</b> field under
						<i>Translate & Adapt > Theme > Section groups > Header group</i>
						matches the Source value in the default language for each translated
						language.
					</p>

					<h4 id="shop-mega-menu">Shop Mega Menu Section</h4>
					<p>
						The Shop Mega Menu section allows you to add a tab block where you
						can set a custom icon and select a submenu. This section also lets
						you display a promo banner and a promo code banner.
					</p>
					<figure>
						<img src="/assets/imgs/docs/mix/shop_mega_menu_1.webp" />
					</figure>
					<ol>
						<li>Add the Shop mega menu section to the Header group.</li>
						<li>
							Fill in the tabs blocks, for each tab block you can customize
							<b>Title</b>, <b>Link</b>, <b>Icon</b> and inner <b>Menu</b>.
						</li>
						<li>
							<b>Promo code</b> options allow you to add and configure a banner
							displaying a promo code with the ability to copy it.
						</li>
						<li>
							<b>Promo banner</b> options allow you to configure a promotional
							banner where you can set an image or video and display a message
							about a collection or promotion.
						</li>
					</ol>

					<!------------------------------ HEADER GROUP (END) ------------------------------>

					<!------------------------------ OVERLAY GROUP (START) ------------------------------>

					<h2 id="overlay-group">Overlay Group</h2>

					<h3 id="popup">Popup</h3>
					<p>
						In the Popup settings, you can change layout, add image, subscribe
						form, customize position, open and exit animations and other
						options.
					</p>
					<figure>
						<img src="/assets/imgs/docs/mix/popup_1.webp" />
					</figure>

					<h3 id="age-verifier">Age Verification Popup</h3>
					<p>
						An Age verification popup is a prompt that appears on a website to
						confirm the user's age before accessing restricted content. In the
						Age verification popup settings, you can change customize text and
						buttons.
					</p>
					<figure>
						<img src="/assets/imgs/docs/mix/age_verification_1.webp" />
					</figure>

					<!------------------------------ OVERLAY GROUP (END) ------------------------------>

					<!------------------------------ FOOTER GROUP (START) ------------------------------>

					<h2 id="footer-group">Footer Group</h2>

					<p>Sections is used on all pages by default.</p>

					<h3 id="footer">Footer</h3>
					<p>
						Footer appears at the bottom of every page. You can customize it to
						fit your brand and product offerings.
					</p>
					<figure>
						<img src="/assets/imgs/docs/mix/footer_1.webp" />
					</figure>
					<ol>
						<li>
							Use <b>Color scheme</b> selector to change the color scheme.
						</li>
						<li>
							<b>Country/region selector</b> field enables the display of the
							region selector in the footer.
						</li>
						<li>
							<b>Language selector</b> field enables the display of the language
							selector in the footer.
						</li>
						<li>
							<b>Payment methods</b> field enables the display of payment
							methods in the bottom line of the footer.
						</li>
						<li>
							<b>Social media icons</b> field enables the display of the social media icons in the footer.
						</li>
						<li><b>Copyright</b> allow to show info about copyright.</li>
						<li>
							<b>Policy Links</b> field enables the display of the policies
							links in the footer.
						</li>
						<li>
							<b>Follow On Shop</b> allow customers to follow your store on the
							Shop app from your storefront, Shop Pay must be enabled.
						</li>
						<li>
							<b>Logo info block</b>
							<ul>
								<li>
									Use the <b>Logo image</b> file selector allows you to select
									or upload your logo file.
								</li>
								<li>
									Use the <b>Logo image secondary</b> file selector to select or
									upload your logo, which can be seen in Dark mode.
								</li>
								<li>
									If you add a logo, you can use the
									<b>Custom logo width </b>slider to change the logo size.
								</li>
								<li>
									<b>Description</b> allows you to add additional description
									under the logo.
								</li>
							</ul>
						</li>
						<li>
							Block <b>Menu</b> allows you to select menus, which will be
							displayed on the top line of the footer.
						</li>
					</ol>

					<!------------------------------ FOOTER GROUP (END) ------------------------------>

					<!------------------------------ SECTIONS (START) ------------------------------>

					<h2 id="all-sections">Sections</h2>
					<p>
						The theme contains several customizable sections that you can add to
						your page in any order.
					</p>

					<h3 id="sections-general-settings">General Settings</h3>
					<p>Settings that are used in almost all sections.</p>

					<h3 id="section-margin">Section Margin</h3>
					<p>Allows you to change the top and bottom margin in the section</p>
					<ol>
						<li>
							<b>Top margin</b> slider allows you to change the top margin in
							the section.
						</li>
						<li>
							<b>Bottom margin</b> slider allows you to change the bottom margin
							in the section.
						</li>
					</ol>
					<figure>
						<img src="/assets/imgs/docs/mix/margin_1.webp" />
					</figure>

					<h3 id="section-padding">Section Padding</h3>
					<p>Allows you to change the top and bottom padding in the section</p>
					<ol>
						<li>
							<b>Top padding</b> slider allows you to change the top padding in
							the section.
						</li>
						<li>
							<b>Bottom padding</b> slider allows you to change the bottom
							padding in the section.
						</li>
					</ol>
					<figure>
						<img src="/assets/imgs/docs/mix/padding_1.webp" />
					</figure>

					<h3 id="featured-collection">Featured Collection</h3>
					<p>
						The section allows you to display products from a selected
						collection. Additionally, you can display up to 2 promo cards or a
						collection card.
					</p>
					<figure>
						<img src="/assets/imgs/docs/mix/featured_collection_1.webp" />
					</figure>
					<ol>
						<li>
							<b>Content options</b> allows you to set a heading,
							button for the section and customize it.
						</li>
						<li>
							<b>Collection</b> allows you to select the featured collection.
						</li>
						<li>
							<b>Overwrite products</b> allows you to select a custom list of
							products that will be displayed instead of the collection's
							products.
						</li>
						<li>
							<b>Color scheme</b> allows you to change the color scheme of the
							slider content.
						</li>
						<li>
							<b>Slider content</b> allows you to display and customize the
							content of a promotion or offer, and set up an image or video for
							display.
						</li>
						<li>
							<b>Slider options</b> allow you to customize slider, switch loop mode, pagination, navigation, autoplay.
						</li>
					</ol>

					<h3 id="featured-product">Featured Product</h3>
					<p>
						In this section, you can display a single product and provide
						information about it. This section is similar to
						<a href="#product-information">Product information</a>, but with
						limited functionality.
					</p>
					<figure>
						<img src="/assets/imgs/docs/mix/featured_product_1.webp" />
					</figure>

					<h3 id="rte">Rich text</h3>
					<p>This section allows you to add Rich text content block.</p>
					<figure>
						<img src="/assets/imgs/docs/mix/rich_text_1.webp" />
					</figure>
					<ol>
						<li>
							<b>Color scheme</b> selector changes the color scheme for the
							section.
						</li>
						<li>
							<b>Full width</b> toggle changes the width of the section (full
							screen or inside container).
						</li>
						<li><b>Position</b> allows you to change content position.</li>
						<li>
							This section contains 4 block types. You can add up to 4 blocks
							(one of each type), including:<br />
							<ol>
								<li><b>Subheading</b> allows you to add a subheading.</li>
								<li>
									<b>Heading</b> allows you to add a heading and customize its
									size.
								</li>
								<li>
									<b>Text</b> allows you to add a description (rich text
									content).
								</li>
								<li>
									<b>Button</b> allows you to add a button and customize it.
								</li>
							</ol>
						</li>
					</ol>

					<h3 id="slideshow">Slideshow</h3>
					<p>
						The section allows you to add slides with image, heading,
						description and promo code.
					</p>
					<figure>
						<img src="/assets/imgs/docs/mix/slideshow_1.webp" />
					</figure>
					<ol>
						<li>
							<b>Full width</b> toggle changes the width of the section (full
							screen or inside container).
						</li>
						<li><b>Aspect ratio</b> sets the aspect ratio of the image.</li>
						<li>
							<b>Slider options</b> allow you to customize slider, switch loop
							mode, pagination, navigation, autoplay.
						</li>
						<li>
							Block <b>Slide</b> option<b> Color scheme</b> allows you to set
							the color scheme for the slide.
						</li>
						<li>
							Block <b>Slide</b> option<b> Image</b> allows you to set a image
							for the slide.
						</li>
						<li>
							Block <b>Slide</b> option<b> Overlay opacity</b> allows you to
							change the opacity of the overlay.
						</li>
						<li>
							Block <b>Slide</b> option<b> Video</b> allows you to set a video
							for the slide.
						</li>
						<li>
							Block <b>Slide</b> option<b> Heading</b> allows you to set a
							heading for the slide.
						</li>
						<li>
							Block <b>Slide</b> option<b> Description</b> allows you to set a
							description for the slide.
						</li>
						<li>
							Block <b>Slide</b> <b>Button options</b> allows you to set a
							button and customize it.
						</li>
					</ol>

					<h3 id="multicolumn">Multicolumn</h3>
					<p>This section allows you to add multiple columns of content.</p>
					<figure>
						<img src="/assets/imgs/docs/mix/multicolumn_1.webp" />
					</figure>
					<ol>
						<li>
							<b>Color scheme</b> selector changes the color scheme for the
							section.
						</li>
						<li>
							<b>Columns per row</b> allows you to select the number of columns
							in one row.
						</li>
						<li>
							Each <b>Column block</b> includes settings that allow you to
							configure the column's content and image.
						</li>
					</ol>

					<h3 id="collapsible-content">Collapsible Content</h3>
					<p>
						You can add and customize a collapsible content section, such as
						using it for FAQs.
					</p>
					<figure>
						<img src="/assets/imgs/docs/mix/collapsible_content_1.webp" />
					</figure>
					<ol>
						<li>
							For each collapsible row block, you can set a
							<b>Heading</b> (question) that will always be displayed and a
							collapsible <b>Description</b> (answer).
						</li>
						<li>You can also choose special rows to be opened by default.</li>
					</ol>

					<h3 id="banner-grid">Banner Grid</h3>
					<p>
						This section allows you to add a grid of cards with background image, texts, tickers, buttons and other elements.
					</p>
					<ol>
						The <b>Layout</b> setting allows you to switch between different grid types for displaying blocks.
						For the best visual result, we recommend following our suggested block combinations shown in the examples for each type.
						<ul>
							<li><b>Type 1</b> — Card with copy, Small card, Small card, Simple card.</li>
							<figure>
								<img src="/assets/imgs/docs/mix/banner_grid_1.webp" />
							</figure>
							<li><b>Type 2</b> — Card with copy, Simple card, Small card, Small card.</li>
							<figure>
								<img src="/assets/imgs/docs/mix/banner_grid_2.webp" />
							</figure>
							<li><b>Type 3</b> — Simple card, Small card, Small card, Small card, Small card, Simple card.</li>
							<figure>
								<img src="/assets/imgs/docs/mix/banner_grid_3.webp" />
							</figure>
							<li><b>Type 4</b> — Simple card, Simple card, Small card, Small card, Small card, Small card.</li>
							<figure>
								<img src="/assets/imgs/docs/mix/banner_grid_4.webp" />
							</figure>
							<li><b>Type 5</b> — Card with copy, Small card, Small card, Small card, Small card.</li>
							<figure>
								<img src="/assets/imgs/docs/mix/banner_grid_5.webp" />
							</figure>
							<li><b>Columns</b> — equal-sized banners arranged in two rows.</li>
							<figure>
								<img src="/assets/imgs/docs/mix/banner_grid_6.webp" />
							</figure>
						</ul>
					</ol>

					<h3 id="banner-slider">Banner Slider</h3>
					<p>
						The section allows you to add slides with image, heading, overlay link and
						badge.
					</p>
					<figure>
						<img src="/assets/imgs/docs/mix/banner_slider_1.webp" />
					</figure>
					<ol>
						<li>
							In the <b>Layout</b> setting choose how the content will be displayed:  
							<ul>
								<li><b>Slider</b> — items will be shown in a horizontal slider with navigation.</li>
								<li><b>Static</b> — items will be displayed as a fixed grid without scrolling.</li>
							</ul>
						</li>
						<li><b>Aspect ratio</b> sets the aspect ratio of the slides.</li>
						<li>
							<b>Slider options</b> allow you to customize slide duration.
						</li>
						<li>
							Block <b>Banner</b> option<b> Color scheme</b> allows you to set
							the color scheme for the slide.
						</li>
						<li>
							Block <b>Banner</b> option<b> Image</b> allows you to set a image
							for the slide.
						</li>
						<li>
							Block <b>Banner</b> option<b> Overlay opacity</b> allows you to
							change the opacity of the overlay.
						</li>
						<li>
							Block <b>Banner</b> option<b> Heading</b> allows you to set a
							heading for the slide.
						</li>
						<li>
							Block <b>Banner</b> option<b> Badge</b> allows you to set a
							badge for the slide.
						</li>
					</ol>

					<h3 id="blog-posts">Featured Blog</h3>
					<p>
						The section allows you to select a blog and display its blog posts.
					</p>
					<figure>
						<img src="/assets/imgs/docs/mix/blog_posts_1.webp" />
					</figure>
					<ol>
						<li>
							<b>Blog</b> field allows you to choose a blog which posts will be
							displayed.
						</li>
						<li>
							<b>Color scheme</b> selector allows you to change the color scheme
							of the section.
						</li>
						<li>
							<b>Header options</b> allows you to set a subheading and heading
							for the section. Header options includes the following:<br />
							<ol>
								<li>
									<b>Section header text</b> allows you to set a text for the
									section header.
								</li>
								<li>
									<b>Section header size</b> allows you to change the size of
									the section header text.
								</li>
							</ol>
						</li>
						<li>
							<b>Posts layout options</b> allows you to customize posts layout.
							Includes following options:<br />
							<ol>
								<li>
									<b>Layout slider</b> allows you to display this section as
									slider.
								</li>
								<li>
									<b>Columns per row</b> slider allows you to select the number of
									posts in one row.
								</li>
								<li>
									<b>Blog posts</b> slider allows you to change the number of
									displayed posts.
								</li>
							</ol>
						</li>
						<li>
							<b>Blog Card Options</b> allows you to customize post's.
							<b>Blog Card Options</b> includes:<br />
							<ol>
								<li>
									<b>Show post image</b> allows you to show or hide post's
									image.
								</li>
								<li>
									<b>Image ratio</b> allows you to choose the orientation of
									pictures for cards.
								</li>
								<li>
									<b>Show post date</b> allows you to show or hide post's date
									of publication in post card.
								</li>
								<li>
									<b>Show post tags</b> allows you to show or hide post's tags
									in post card.
								</li>
								<li>
									<b>Show post author</b> allows you to show or hide post's
									author in post card.
								</li>
								<li>
									<b>Show post excerpt</b> allows you to show or hide post's
									excerpt in post card.
								</li>
							</ol>
						</li>
					</ol>

					<h3 id="brands">Logo List</h3>
					<p>
						Showcase your partners or affiliations with this section. This
						section is perfect for building credibility and showcasing key
						partnerships effectively.
					</p>
					<figure>
						<img src="/assets/imgs/docs/mix/brands_1.webp" />
					</figure>
					<ol>
						<li>
							In the <b>Layout</b> setting choose how the content will be displayed:  
							<ul>
								<li><b>Slider</b> — items will be shown in a horizontal slider with navigation.</li>
								<li><b>Static</b> — items will be displayed as a fixed grid without scrolling.</li>
							</ul>
						</li>
						<li>
							<b>Color scheme</b> allows you to change the color scheme of the
							section.
						</li>
						<li>
							<b>Main options</b> allows you to set a heading, description and button for
							the section and customize it.
						</li>
						<li>
							The <b>Logo block</b> lets you showcase your own brands or your
							partners’ brands. Each Logo block includes image settings and an
							option to set a width.
						</li>
					</ol>

					<h3 id="collections-list">Collections List</h3>
					<p>Displays a list of featured collections.</p>
					<figure>
						<img src="/assets/imgs/docs/mix/collections_list_1.webp" />
					</figure>
					<ol>
						<li>
							In the <b>Layout</b> setting choose how the content will be displayed:  
							<ul>
								<li><b>Slider</b> — items will be shown in a horizontal slider with navigation.</li>
								<li><b>Static</b> — items will be displayed as a fixed grid without scrolling.</li>
							</ul>
						</li>
						<li>
							<b>Color scheme</b> allows you to change the color scheme of the
							section.
						</li>
						<li>
							<b>Main options</b> allows you to set a heading, description for
							the section and customize it.
						</li>
						<li>
							<b>Image ratio</b> allows you to set the aspect ratio of the
							image.
						</li>
						<li>
							<b>Collection</b> block allows you to select collection and
							customize it. Includes following options:<br />
							<ol>
								<li><b>Collection</b> allows you to select collection.</li>
								<li>
									<b>Image</b> field allows you to overwrite collection's
									featured image.
								</li>
							</ol>
						</li>
					</ol>

					<h3 id="countdown">Countdown</h3>
					<p>
						You can add and customize a countdown timer.
					</p>
					<figure>
						<img src="/assets/imgs/docs/mix/countdown_1.webp" />
					</figure>
					<ol>
						<li>
							<b>Color scheme</b> allows you to change the color scheme of the
							section.
						</li>
						<li>
							The <b>End year</b>, <b>End month</b>, <b>End day</b>,
							<b>End hour</b> and <b>End minutes</b> options allow you to set
							the countdown's end date and end time.
						</li>
						<li>
							<b>After the timer ends</b> allows you to specify what should
							happen when the countdown is completed: either the section will be
							hidden, or a special text will be displayed.
						</li>
						<li>
							<b>Text after the timer ends</b> will be shown if the
							<i>Show text</i> option is selected.
						</li>
						<li>
							The <b>Image</b> option allows you to set an image for the
							section.
						</li>
						<li>
							The <b>Overlay opacity</b> allows you to adjust the overlay's
							opacity to the image.
						</li>
					</ol>

					<h3 id="product-carousel">Popular Products</h3>
					<p>
						The section allows you to display popular products and customize
						their display.
					</p>
					<figure>
						<img src="/assets/imgs/docs/mix/popular_products_1.webp" />
					</figure>
					<ol>
						<li>
							You can set the number of blocks per row using the
							<b>Products per row</b> option.
						</li>
						<li>
							Additionally, you can customize the product cards options in this
							section.
						</li>
						<li>
							The <b>Button options</b> allow you to set a button and customize
							it.
						</li>
					</ol>

					<h3 id="product-markers">Product Markers</h3>
					<p>
						The section allows you to mark products in the image and choose
						display position.
					</p>
					<figure>
						<img src="/assets/imgs/docs/mix/product_markers_1.webp" />
					</figure>
					<ol>
						<li>
							<b>Product marker block</b> allows you to select a product, image
							and set the position of its marker.
						</li>
						<li><b>Image ratio</b> sets the aspect ratio of the image.</li>
					</ol>

					<h3 id="product-tabs">Collection Tabs</h3>
					<p>
						This section allows you to display a set of products into tabs using collections.
					</p>
					<figure>
						<img src="/assets/imgs/docs/mix/product_tabs_1.webp" />
					</figure>
					<ol>
						<li>
							In the <b>Layout</b> setting choose how the content will be displayed:  
							<ul>
								<li><b>Slider</b> — items will be shown in a horizontal slider with navigation.</li>
								<li><b>Static</b> — items will be displayed as a fixed grid without scrolling.</li>
							</ul>
						</li>
						<li>
							<b>Columns per row</b> slider allows you to select the number of
							products in one row.
						</li>
						<li>
							<b>Collections</b> — select one or multiple collections, products from them will be displayed in this block.
						</li>
						<li>
							<b>Product count</b> — set how many products will be shown from the selected collections.
						</li>
						<li>
							<b>Slider options</b> allow you to customize slider, navigation, autoplay.
						</li>
					</ol>

					<h3 id="testimonials">Testimonials</h3>
					<p>
						This section allows you to add and customize testimonials (clients
						reviews).
					</p>
					<figure>
						<img src="/assets/imgs/docs/mix/testimonials_1.webp" />
					</figure>
					<ol>
						<li>
							<b>Main options</b> allows you to set a color scheme, heading and
							description for the section and customize it.
						</li>
						<li>
							<b>Testimonials slide</b> block allows you to add and customize
							testimonials (clients reviews). Each block has the following
							options:<br />
							<ol>
								<li>
									<b>Product</b> allows you to set a product that is related to
									the review.
								</li>
								<li><b>Review score</b> allows you to set a review score.</li>
								<li><b>Text</b> allows you to set a text of the review.</li>
								<li>
									<b>Author's name</b> allows you to set the name of the author
									of the review.
								</li>
								<li>
									<b>Author's position</b> allows you to set the position of the author
									of the review.
								</li>
							</ol>
						</li>
					</ol>

					<!------------------------------ SECTIONS (END) ------------------------------>

					<!------------------------------ PAGES (START) ------------------------------>

					<h2 id="page">Pages</h2>

					<p>Information on theme pages.</p>

					<h3 id="product-page">Product Page</h3>

					<h4 id="product-information">Product Information</h4>
					<p>
						The Product information section allows users to view all relevant
						information about the product.
					</p>
					<figure>
						<img src="/assets/imgs/docs/mix/product_information_1.webp" />
					</figure>
					<ol>
						<li>
							Using the <b>Gallery type</b> selector allows you to choose gallery type.
						</li>
						<li>
							<b>Desktop product gallery alignment</b> selector allows you to choose alignment type on desktop devices.
						</li>
						<li>
							<b>Mobile product gallery alignment</b> selector allows you to choose alignment type on mobile devices.
						</li>
						<li>
							With the <b>Aspect ratio</b> setting, you can set aspect ratios
							for the images in the gallery.
						</li>
						<li>
							In this section, you can add dropdown information, multicolumn information, pickup and delivery
							information, popup banner, characteristics, complementary products and product recommendations.
						</li>
						<li>Characteristics block shows a list of <b>characteristics</b> for the product, if they exist in its metafields.
							To enable this block, need add a metafield custom.characteristics in Shopify admin.
							<p>To add and edit metafields, follow these steps:</p>
							<ol>
								<li>
									Navigate to Settings > Metafields and metaobjects in the Admin panel > Click the button "Add definition".
									<figure>
										<img src="/assets/imgs/docs/mix/custom_badges_2.webp" />
									</figure>
								</li>
								<li>
									Fill the fields. In the <b>Name</b> field enter "Characteristic" so that
									"characteristic" appears in the Type field.
									In the <b>Fields</b> section add:
									<ul>
										<li><b>Title</b> (Single line text) — key: <code>characteristic.title</code></li>
										<li><b>Description</b> (Single line text) — key: <code>characteristic.description</code></li>
									</ul>
									<figure>
										<img src="/assets/imgs/docs/mix/custom_characteristic_3.webp" />
									</figure>
								</li>
								<li>
									Select Products.
									<figure>
										<img src="/assets/imgs/docs/mix/custom_badges_4.webp" />
									</figure>
								</li>
								<li>
									Click the button "Add definition".
									<figure>
										<img src="/assets/imgs/docs/mix/custom_badges_5.webp" />
									</figure>
								</li>
								<li>
									Fill the fields. In the <b>Name</b> field enter "Characteristics" so that
									"custom.characteristics" appears in the Namespace and Key field.
									In the <b>Content type</b> section select <b>Mixed reference</b>.
									In the <b>References</b> field choose <b>Characteristic</b> and set limit to "List of entries".
									<figure>
										<img src="/assets/imgs/docs/mix/custom_characteristic_6.webp" />
									</figure>
								</li>
								<li>
									Go to <b>Content → Metaobjects</b> and make sure that the definition
									<b>Characteristic</b> has been created successfully.
									You should see it in the list with the assigned author and number of entries.
									<figure>
										<img src="/assets/imgs/docs/mix/custom_characteristic_7.webp" />
									</figure>
								</li>
								<li>
									Click the button "Add entry".
									<figure>
										<img src="/assets/imgs/docs/mix/custom_characteristic_8.webp" />
									</figure>
								</li>
								<li>
									Add a new entry for <b>Characteristic</b>.
									Fill in the following fields:
									<ul>
										<li><b>Title</b> — enter the display name of the characteristic</li>
										<li><b>Description</b> — enter the description of the characteristic</li>
									</ul>
									Make sure the <b>Status</b> is set to <b>Active</b>.
									<figure>
										<img src="/assets/imgs/docs/mix/custom_characteristic_9.webp" />
									</figure>
								</li>
								<li>
									Go to <b>Products</b> and open the product where you want to display a Characteristics.
									In the <b>Product metafields</b> section find <b>Characteristics</b> and select the
									corresponding entry from the list (for example: <i>Dimensions, mm</i>, <i>Product weight, g</i>, etc.).
									<figure>
										<img src="/assets/imgs/docs/mix/custom_characteristic_10.webp" />
									</figure>
								</li>
							</ol>
						</li>
					</ol>

					<h4 id="product-recommendations">Product Recommendations</h4>
					<p>
						Dynamic recommendations use order and product information to change
						and improve over time.
					</p>
					<p>
						To add and edit product recommendations, install the
						<b>Search & Discovery app</b> by Shopify from the Apps page in the
						Admin panel. Once installed, open the app and follow the
						"Recommendations" link in the Feature overview section to add
						recommendations to your products.
					</p>
					<figure>
						<img
							src="/assets/imgs/docs/mix/product_recommendations_1.webp"
						/>
					</figure>

					<p>Settings for this section look like below:</p>
					<figure>
						<img
							src="/assets/imgs/docs/mix/product_recommendations_2.webp"
						/>
					</figure>
					<ol>
						<li><b>Heading</b> allows you to set a heading for the section.</li>
						<li>
							<b>Heading size</b> selector field allows you to change the size
							of the section header.
						</li>
						<li>
							<b>Product card</b> options allow you to customize product cards
							in the section.
						</li>
					</ol>

					<h3 id="collections-page">Collections Page</h3>
					<figure>
						<img src="/assets/imgs/docs/mix/collection_page_1.webp" />
					</figure>

					<h4 id="collection-banner">Collection Banner</h4>
					>
					<ol>
						<li><b>Show collection image</b> field turn on image display.</li>
						<li>
							<b>Image for "Products" page</b> image for automatically generated
							page with all products.
						</li>
					</ol>

					<h4 id="product-grid">Product Grid</h4>
					<ol>
						<li>
							<b>Products per page</b> field sets the number of displayed cards.
						</li>
						<li>
							<b>Product card</b> options allow you to customize product cards
							in the section.
						</li>
						<li><b>Enable filtering</b> field turn filtering.</li>
						<li><b>Enable sorting</b> field turn sorting.</li>
					</ol>

					<h3 id="collections-list-page">Collections List</h3>
					<p>Displays a list of all collections.</p>
					<figure>
						<img
							src="/assets/imgs/docs/mix/collection_list_page_1.webp"
						/>
					</figure>
					<ol>
						<li><b>Heading</b> field sets a header section.</li>
						<li>
							<b>Collections per row</b> slider allows you to change the number
							of collections per line only on desktop devices.
						</li>
						<li>
							<b>Sort collections by</b> field filters the collection by the
							specified parameters
						</li>
						<li>
							<b>Image ratio</b> field allows you to choose the orientation of
							images for cards.
						</li>
						<li>
							<b>Show description</b> enables the display of the collection
							description.
						</li>
					</ol>

					<h3 id="cart">Cart</h3>
					<figure>
						<img src="/assets/imgs/docs/mix/cart_page_1.webp" />
					</figure>

					<h4 id="cart-shipping">Free shipping message</h4>
					<p>
						To add and edit cart free shipping progress bar, follow these steps:
					</p>
					<ol>
						<li>
							Enable the Theme settings > Cart > Free shipping message > Show
							free shipping message.
						</li>

						<li>
							Set the value required to qualify for free shipping. This value
							should be specified in the store's default currency. For customers
							using other currencies, conversion will be applied.
						</li>

						<li>
							Create a
							<a
								href="https://help.shopify.com/en/manual/discounts/discount-types/free-shipping"
								target="_blank"
								>free shipping discount</a
							>
							in the store and set the same amount, or configure a
							<a
								href="https://help.shopify.com/en/manual/fulfillment/setup/shipping-rates/flat-shipping-rates#create-free-shipping-rates"
								target="_blank"
								>shipping rate</a
							>.
						</li>

						<li>
							To create and edit a shipping rate, go to the store settings under
							the Shipping and delivery tab.
						</li>
					</ol>

					<h3 id="blog">Blog</h3>
					<figure>
						<img src="/assets/imgs/docs/mix/blog_page_1.webp" />
					</figure>
					<ol>
						<li>
							<b>Posts per page</b> slider allows you to change the number of
							posts per page.
						</li>
						<li>
							<b>Featured posts</b> options allows you to customize featured
							post. <b>Featured post</b> options
							includes:<br />
							<ol>
								<li>
									<b>Image ratio</b> allows you to set the aspect ratio of the
									Featured posts slider on desktop devices.
								</li>
								<li>
									<b>Show date</b> allows you to show or hide post's date of
									publication in featured post.
								</li>
								<li>
									<b>Show tags</b> allows you to show or hide post's tags in
									featured post.
								</li>
								<li>
									<b>Show author</b> allows you to show or hide post's author in
									featured post.
								</li>
								<li>
									<b>Show excerpt</b> allows you to show or hide post's excerpt
									in featured post.
								</li>
							</ol>
						</li>
						<li>
							<b>Post content options</b> allows you to customize post's image
							and content.<br />
							Post content options includes:<br />
							<ol>
								<li>
									<b>Show image</b> allows you to show or hide post's image.
								</li>
								<li>
									<b>Image ratio</b> allows you to choose the orientation of
									pictures for cards.
								</li>
								<li>
									<b>Image fit</b> allows you to choose the fit of pictures for
									cards.
								</li>
								<li>
									<b>Show date</b> allows you to show or hide post's date of
									publication in post card.
								</li>
								<li>
									<b>Show tags</b> allows you to show or hide post's tags in
									post card.
								</li>
								<li>
									<b>Show author</b> allows you to show or hide post's author in
									post card.
								</li>
								<li>
									<b>Show excerpt</b> allows you to show or hide post's excerpt
									in post card.
								</li>
							</ol>
						</li>
					</ol>

					<h3 id="blog-post">Blog Post</h3>
					<figure>
						<img src="/assets/imgs/docs/mix/blogpost_1.webp" />
					</figure>
					<ol>
						<li>
							This section contains 4 block types:<br />
							<ol>
								<li><b>Article header</b></li>
								<li><b>Content</b></li>
								<li><b>Article footer</b></li>
								<li><b>Sidebar</b></li>
							</ol>
						</li>
						<li>
							<b>Article header</b> block has following options:
							<ol>
								<li>
									<b>Show excerpt</b> allows you to show or hide post's excerpt
									in article header.
								</li>
								<li>
									<b>Show date</b> allows you to show or hide post's date of
									publication in article's header.
								</li>
								<li>
									<b>Show author</b> allows you to show or hide post's author in
									article's header.
								</li>
								<li>
									<b>Show tags</b> allows you to show or hide post's tags in
									article's header.
								</li>
							</ol>
						</li>
						<li>
							<b>Article footer</b> block has following options:
							<ol>
								<li>
									<b>Show author</b> allows you to show or hide post's author in
									article's footer.
								</li>
								<li>
									<b>Show tags</b> allows you to show or hide post's tags in
									article's footer.
								</li>
								<li>
									<b>Show date</b> allows you to show or hide post's date of
									publication in article's footer.
								</li>
								<li>
									<b>Share</b> options allows you to enable share block and each
									share link from the list.
								</li>
							</ol>
						</li>
						<li>
							<b>Sidebar</b> block allows you to display the blog and show them in the
							sidebar, and add a promo banner.
						</li>
					</ol>

					<!------------------------------ PAGES (END) ------------------------------>

					<!------------------------------ SUPPORT ------------------------------>

					<h2 id="support">Support</h2>

					<p>
						You can ask any questions about the theme and our support agent will
						help you within 24 hours on business days.
					</p>
					<router-link to="/help-center/" class="sh-link-arrow">
						<span class="sh-link-arrow__name">Visit Help Center</span>
						<span class="sh-link-arrow__icon">
							<svg
								viewBox="0 0 24 25"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M16.004 9.914L7.39697 18.521L5.98297 17.107L14.589 8.5H7.00397V6.5H18.004V17.5H16.004V9.914Z"
									fill="currentColor"
								></path>
							</svg>
						</span>
					</router-link>
					&nbsp;&nbsp;&nbsp;&nbsp;
					<router-link to="/privacy/" class="sh-link-arrow">
						<span class="sh-link-arrow__name">View Terms & Conditions</span>
						<span class="sh-link-arrow__icon">
							<svg
								viewBox="0 0 24 25"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M16.004 9.914L7.39697 18.521L5.98297 17.107L14.589 8.5H7.00397V6.5H18.004V17.5H16.004V9.914Z"
									fill="currentColor"
								></path>
							</svg>
						</span>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">
@import "@/assets/scss/_documentation.scss";
</style>

<script setup>
import { onMounted } from "vue";

onMounted(() => {
	const sidebar = document.querySelector(
		".sh-documentation-theme__sidebar-nav"
	);

	if (!sidebar) return;

	sidebar.addEventListener("click", (e) => {
		const link = e.target.closest("a");
		if (!link || !link.hash) return;

		const targetId = link.hash.slice(1);
		const targetElement = document.getElementById(targetId);
		if (!targetElement) return;

		e.preventDefault();

		const targetPosition =
			targetElement.getBoundingClientRect().top + window.pageYOffset;
		window.scrollTo({
			top: targetPosition - 32,
			behavior: "smooth",
		});
	});
});
</script>
